/**
 * Whether the error is a failure to load a lazily loaded code file, as happens in a tab opened
 * before a deployment that deleted the file. Recognises webpack's errors (the current builder) and
 * the dynamic-import errors of each browser (Angular's esbuild builder).
 */
const chunkLoadErrorMessages = [
  /Loading chunk [\w-]+ failed/i, // webpack, JavaScript
  /Loading CSS chunk [\w-]+ failed/i, // webpack, styles
  /Failed to fetch dynamically imported module/i, // Chrome
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
];

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  return (
    error.name === 'ChunkLoadError' ||
    chunkLoadErrorMessages.some(pattern => pattern.test(error.message))
  );
}
